import React, { useState, useEffect } from "react";
import { FormControl, Input } from "@material-ui/core";
import Message from "./component/Message";
import "./App.css";
import db from "./firebase";
import firebase from "firebase";
import FlipMove from "react-flip-move";
import { IconButton } from "@material-ui/core";
import SendIcon from "@material-ui/icons/Send";

function App() {
  const [message, setMessage] = useState("");
  const [messageCollection, setMessageCollection] = useState([]);
  const [username, setUsername] = useState("");

  // useEffect for setting up the messages...
  useEffect(() => {
    db.collection("messages")
      .orderBy("timestamp", "desc")
      .onSnapshot((snapshot) => {
        console.log(snapshot.docs);
        setMessageCollection(
          snapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id }))
        );
      });
  }, []);

  // useEffect call for setting the username
  useEffect(() => {
    if (localStorage.getItem("Chat_username")) {
      setUsername(localStorage.getItem("Chat_username"));
      return;
    }
    const username = prompt("Enter Your Username");
    setUsername(username);
    localStorage.setItem("Chat_username", username);
  }, []);

  const handleOnClickChange = (event) => {
    // prevent the page form refreshing....
    event.preventDefault();

    db.collection("messages").add({
      message,
      username,
      timestamp: firebase.firestore.FieldValue.serverTimestamp(),
    });

    setMessage("");
  };

  return (
    <div>
      {/* info boxes */}
      <div className="info__box">
        <img
          src="https://facebookbrand.com/wp-content/uploads/2018/09/Header-e1538151782912.png?w=100&h=100"
          alt="messenger_logo"
          className="logo__messenger"
        />
        <h2>
          Welcome to The Messenger Clone built By Sajjan Karn!{" "}
          <span role="img"></span>🚀
        </h2>
        <p style={{ padding: "30px 0", fontSize: "1.3rem" }}>
          Welcome: {username}
        </p>
      </div>

      <form
        className="input__container"
        onSubmit={(e) => handleOnClickChange(e)}
      >
        <FormControl className="input__containers__main">
          <Input
            style={{ width: "25vw" }}
            onChange={(e) => setMessage(e.target.value)}
            value={message}
            placeholder="Enter a Message :)"
            className="input__box"
          />
          <IconButton
            variant="contained"
            color="primary"
            type="submit"
            style={{ margin: "0 20px" }}
            className="icon__messenger"
            disabled={message === "" ? true : false}
          >
            <SendIcon />
          </IconButton>
        </FormControl>
      </form>

      {/* input containers */}

      {/* messages */}
      <div className="messsage_container">
        <FlipMove>
          {messageCollection.map((message) => {
            return (
              <Message username={username} message={message} key={message.id} />
            );
          })}
        </FlipMove>
      </div>
    </div>
  );
}

export default App;
